import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

let customCheckout = window.customcheckout && window.customcheckout();

export const createToken = () =>
  new Promise((resolve, reject) => {
    customCheckout.createToken(result => {
      if (result.error) {
        reject(result.error);
      } else {
        resolve({ ok: true, data: result });
      }
    });
  });

const style = {
  base: {
    padding: '1rem',
    fontSize: '16px',
    color: '#595959',
    fontFamily: "'Open Sans' sans-serif",
  },
};

const StyledErrorP = styled.p`
  color: ${colors.YUHU_RED};
`;

export const BamboraFields = () => {
  const [cardNumberError, setCardNumberError] = useState(null);
  const [expiryError, setExpiryError] = useState(null);
  const [cvvError, setCvvError] = useState(null);

  if (!customCheckout) {
    customCheckout = window.customcheckout();
  }

  useEffect(() => {
    customCheckout
      .create('card-number', { placeholder: getTranslatedString('bpms.creditCard'), style })
      .mount('#card-number');
    customCheckout
      .create('cvv', { placeholder: getTranslatedString('bpms.cvv'), style })
      .mount('#card-cvv');
    customCheckout
      .create('expiry', { placeholder: getTranslatedString('bpms.expiryDate'), style })
      .mount('#card-expiry');
    customCheckout.on('error', e => {
      const errorMessage = getTranslatedString('bpms.' + e.type);
      if (e.field === 'card-number') {
        setCardNumberError(errorMessage);
      } else if (e.field === 'expiry') {
        setExpiryError(errorMessage);
      } else if (e.field === 'cvv') {
        setCvvError(errorMessage);
      }
    });
    customCheckout.on('complete', e => {
      if (e.field === 'card-number') {
        setCardNumberError(null);
      } else if (e.field === 'expiry') {
        setExpiryError(null);
      } else if (e.field === 'cvv') {
        setCvvError(null);
      }
    });
    return () => {
      customCheckout = null;
    };
  }, []);

  return (
    <div>
      <div id="card-number" />
      {cardNumberError && <StyledErrorP>{cardNumberError}</StyledErrorP>}

      <div id="card-cvv" />
      {cvvError && <StyledErrorP>{cvvError}</StyledErrorP>}

      <div id="card-expiry" />
      {expiryError && <StyledErrorP>{expiryError}</StyledErrorP>}
    </div>
  );
};
